<template>
	<div>
		<a-form-model ref="addForm"  :model="theObj" :rules="rules" :label-col="{span:'5'}" :wrapper-col="{span:'19'}">
			<a-form-model-item label="单价名" prop="kindName">
				<a-input v-model="theObj.kindName"></a-input>
			</a-form-model-item>
			<a-form-model-item label="备注">
				<a-input v-model="theObj.kindRemark"></a-input>
			</a-form-model-item>
			<a-form-model-item label="基本单价名" prop="basicPriceName">
				<a-input v-model="theObj.basicPriceName"></a-input>
			</a-form-model-item>
			<a-row :gutter="2">
				<a-col :span="12">
					<a-form-model-item label="一阶单价" prop="firstPrice" :label-col="{span:'10'}" :wrapper-col="{span:'14'}">
						<a-input-number id="inputNumber" v-model="theObj.firstPrice" :min="0.0" :precision="2" style="width: 7rem;"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="12">
					<a-form-model-item label="一阶超量" prop="firstOver" :label-col="{span:'10'}" :wrapper-col="{span:'14'}">
						<a-input-number id="inputNumber" v-model="theObj.firstOver" :min="0" :precision="0" style="width: 7rem;"/>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row :gutter="2">
				<a-col :span="12">
					<a-form-model-item label="二阶单价" prop="secondPrice" :label-col="{span:'10'}" :wrapper-col="{span:'14'}">
						<a-input-number id="inputNumber" v-model="theObj.secondPrice" :min="0.0" :precision="2"  style="width: 7rem;"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="12">
					<a-form-model-item label="二阶超量" prop="secondOver" :label-col="{span:'10'}" :wrapper-col="{span:'14'}">
						<a-input-number id="inputNumber" v-model="theObj.secondOver" :min="0" :precision="0"  style="width: 7rem;"/>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row :gutter="2">
				<a-col :span="12">
					<a-form-model-item label="三阶单价" prop="thirdPrice" :label-col="{span:'10'}" :wrapper-col="{span:'14'}">
						<a-input-number id="inputNumber" v-model="theObj.thirdPrice" :min="0.0" :precision="2"  style="width: 7rem;"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="12">
					<a-form-model-item label="每人增量" prop="over" :label-col="{span:'10'}" :wrapper-col="{span:'14'}">
						<a-input-number id="inputNumber" v-model="theObj.over" :min="0.0" :precision="0"  style="width: 7rem;"/>
					</a-form-model-item>
				</a-col>
			</a-row>
		</a-form-model>
		<div class="drawerFooter">
		    <a-button icon="close" @click="onClose(false)" style="margin-right: 0.625rem;">取 消</a-button>
		    <a-button  icon="check" type="primary" :loading="submitFlag" @click="onSubmit">提 交</a-button>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				theObj:{
					kindName:null,
					kindRemark:null,
					basicPriceName:null,
					firstPrice:0.0,
					firstOver:0,
					secondPrice:0.0,
					secondOver:0,
					thirdPrice:0.0,
					over:0,
				},
				submitFlag:false,
				rules:{
					kindName:[{required:true,message:'请输入单价名',trigger: 'blur'}],
					basicPriceName:[{required:true,message:'请输入基本单价名',trigger: 'blur'}],
					firstPrice:[{required:true,message:'请输入一阶单价',trigger: 'blur'}],
					firstOver:[{required:true,message:'请输入一阶超量',trigger: 'blur'}],
					secondPrice:[{required:true,message:'请输入二阶单价',trigger: 'blur'}],
					secondOver:[{required:true,message:'请输入二阶超量',trigger: 'blur'}],
					thirdPrice:[{required:true,message:'请输入三阶单价',trigger: 'blur'}],
					over:[{required:true,message:'请输入每人增量',trigger: 'blur'}]
				},
			}
		},
		methods:{
			onClose:function(flag){
				this.$emit('cancelAdd');
				if(flag){
					this.$emit('refreshList');
				}
			},
			onSubmit:function(){
				this.submitFlag = true;
				let url = this.Api.getLastUrl(this.Api.BASIC_PRICE_ADD_URL);
				this.Api.fetchPostWithJson(url,this.theObj).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.onClose(true);
						this.$message.success('新增单价成功');
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.submitFlag = false;
				})
			},
		}
	}
</script>

<style>
</style>
